import { FC, memo } from 'react'
import { Button } from '@blueprintjs/core'
import { usePdfEditor } from './PdfEditorProvider'
import useCallbackDebounced from '../../../hooks/shared/useCallbackDebounced'

const CloseButton: FC = () => {
  const { onClose, updated, saving } = usePdfEditor()
  const handleCloseClicked = useCallbackDebounced(() => {
    onClose(updated)
  }, [onClose, updated])
  return (
    <Button
      icon="cross"
      intent="none"
      variant="minimal"
      onClick={handleCloseClicked}
      disabled={saving}
    />
  )
}

export default memo(CloseButton)
